var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 855,
    height: 286,
    viewBox: "0 0 855 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M854.5 195.5C854.5 195.5 744.721 286 429.065 286C113.409 286 0.5 199 0.5 199C0.5 199 113.409 10 429.065 10C744.721 10 854.5 195.5 854.5 195.5Z",
    fill: "#EA6C30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M845.5 187.5C845.5 187.5 739.504 275.5 430.5 275.5C121.497 275.5 9.5 187.5 9.5 187.5C9.5 187.5 121.497 0 430.5 0C739.504 0 845.5 187.5 845.5 187.5Z",
    fill: "#9E7A08"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure);
export default __webpack_public_path__ + "static/media/figure.89e1e8c119010d6c4e916394ee627ff6.svg";
export { ForwardRef as ReactComponent };